import { KText } from '@/ui-library/components/text';
import {
  Avatar,
  AvatarGroup,
  Box,
  Flex,
  Icon,
  Tooltip,
} from '@chakra-ui/react';
import { Users01 } from '@kula-ai/icons/outline/Users01';

export const InterviewersInfo = ({
  users = [],
  isHeader = false,
  styles = {},
  size = 'xs',
  borderRadius = '8px',
}) => {
  return (
    <Flex gap="12px" alignItems="center" {...styles}>
      {!isHeader && <Icon as={Users01} />}
      {!isHeader && <KText size="sm-regular">Interviewers</KText>}
      <AvatarGroup size="xs">
        {users?.map((user, index) => (
          <Tooltip
            key={`${user?.id}-${index}`}
            label={users?.length > 1 ? user?.name : ''}
            variant="ats-primary"
            hasArrow
          >
            <Box h="20px">
              <Avatar
                name={user?.name}
                src={user?.avatar}
                borderRadius={borderRadius}
                size={size}
                ml={index > 0 ? '-5px' : 0}
                borderRight="2px solid white"
                w="20px"
                h="20px"
              />
            </Box>
          </Tooltip>
        ))}
        {users?.length === 1 && (
          <Flex ml="5px">
            <KText size="sm-medium" color="secondary-700">
              {users[0]?.name}
            </KText>
          </Flex>
        )}
      </AvatarGroup>
    </Flex>
  );
};
